module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/youtube-8db15167d52b991f3d68745983d45a12.svg&quot;;"